import React, { FC } from 'react'
import { SelectProps } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = makeStyles((theme: Theme) => ({
  arrow: {
    color: theme.palette.primary.main,
    opacity: '60%',
    marginTop: -10,
  },
}))

export const SelectArrow: FC = (props: SelectProps) => {
  const { arrow } = useStyles()

  return <ExpandMoreIcon className={`${arrow} + ${props.className}`} />
}
